import * as React from 'react';
import {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
    Stack
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import {parseISO} from "date-fns";
import {useTranslation} from "react-i18next";
import FormItem from "../form-item/FormItem";
import {useUpdateExpenseMutation} from "../../store";
import ExpenseDto from "../../dto/ExpenseDto";
import ExpenseUpdateRequestDto from "../../dto/ExpenseUpdateRequestDto";


interface Props {
    expense: ExpenseDto,
    onSave: any
}

export default function ExpenseEditDialog(props: Props) {
    const {t} = useTranslation();
    const {expense, onSave} = props;
    const {register, getValues, setValue, formState: {errors}} = useForm();
    const [open, setOpen] = useState(false);
    const [updateExpense, {isLoading, error}] = useUpdateExpenseMutation();
    const parseDate = (date: string) => {
        return parseISO(date);
    }
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const onSubmit = async (data: any) => {
        const request = data as ExpenseUpdateRequestDto;
        request.id = expense.id;
        await updateExpense(request);
        setOpen(false);
        onSave();
    };

    const onChangeNote = (event: any) => {
        setValue("note", event.target.value);
    }

    const initForm = () => {
        setValue("note", expense.note);
    };

    useEffect(() => {
        initForm();
    }, []);

    return (
        <div>
            <IconButton onClick={handleClickOpen}>
                <EditIcon/>
            </IconButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{t("Edit expense")}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t("Edit expense")}: {expense.fileName}
                    </DialogContentText>
                    <form>
                        <Box sx={{width: '100%'}}>
                            <Stack spacing={2}>
                                <FormItem>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="adornment-amount">
                                            {t("Note")}
                                        </InputLabel>
                                        <OutlinedInput
                                            fullWidth
                                            type="string"
                                            inputProps={{
                                                inputMode: "decimal",
                                                autoComplete: "off"
                                            }}
                                            defaultValue={expense.note}
                                            {...register("note", {required: true})}
                                            onChange={onChangeNote}
                                        />
                                        {errors.note && <FormHelperText>{t("Note is required")}</FormHelperText>}
                                    </FormControl>
                                </FormItem>
                            </Stack>
                        </Box>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit" onClick={() => onSubmit(getValues())}>{t("Save")}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};